import type { LcgRng } from "./lcg.js";

export function shuffle<T>(items: readonly T[], rng: LcgRng): T[] {
  const copy = items.slice();

  for (let i = copy.length - 1; i > 0; i -= 1) {
    const j = Math.floor(rng.nextRandom() * (i + 1));
    const tmp = copy[i];
    copy[i] = copy[j];
    copy[j] = tmp;
  }

  return copy;
}
